import React from 'react'
import injectStyles from 'react-jss'
import { styles } from './styles'

const LinkListItem = ({ href, target, text, classes }) => {
  return (
    <a href={href} target={target} className={classes.container}>
      {text}
    </a>
  )
}

export default injectStyles(styles)(LinkListItem)
